import "./plantationSponsored.css";
import React, { useState, useEffect } from "react";
import {
  authKey,
  GET_DROPDOWN_FOR_PLANTATION_BATCH,
  UPLOAD_DCUMENT,
} from "../../../common/URLs";

import { loaderService } from "../../../common/custom-loader/loader-service";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import {
  FILE_NAME_VALIDATION_ERROR,
  PROD,
  allowedFileTypes,
} from "../../../common/constants";
import {
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Paper,
  Divider,
} from "@mui/material";
import BackButton from "../../../common/backButton";
import {
  VALIDATION,
  fileNameValidation,
  openTextFieldMaxLength,
} from "../../../common/commonValidations";
import apiClient from "../../../axios";

function PlantationSponsored() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;

  const [urn, setUrn] = useState();
  const [sponsoredType, setSponsoredType] = useState();
  const [documentUploadDetails, setDocumentUploadDetails] = useState();
  const [selectedFile, setSelectedFile] = useState();

  const [sponosoreDetails, setSponosoreDetails] = useState({
    isSponsored: "no",
    sponsoredType: "",
    sponsoredRemarks: "",
    sponsoredDocument: "",
    sponsoredDocumentGuid: "",
  });

  const [errorMessage, setErrorMessage] = useState({
    isSponsoredError: "",
    sponsoredTypeError: "",
    sponsoredRemarksError: "",
    sponsoredDocumentError: "",
  });

  useEffect(() => {
    if (state?.urn) {
      setUrn(state?.urn);
    }
  }, [state]);

  useEffect(() => {
    if (selectedFile) {
      getUploadDocumentDetails();
    }
  }, [selectedFile]);

  useEffect(() => {
    getSponsoredValues();
  }, [urn]);

  const uploadDocument = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (allowedFileTypes.indexOf(file.type) < 0) {
      return;
    }

    if (file.size >= 5000000) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: "The file should be less than 5MB",
      });
    } else if (file.name.split(".").length > 2) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: "Double extension file detected",
      });
      setSelectedFile();
    } else if (fileNameValidation(file.name)) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: FILE_NAME_VALIDATION_ERROR,
      });
      setSelectedFile();
    } else {
      setSelectedFile(file);
      setErrorMessage({ ...errorMessage, sponsoredDocumentError: "" });
    }
  };

  function getUploadDocumentDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", selectedFile.name);
    formData.append("containerName", "resourcefiles");

    apiClient
      .post(UPLOAD_DCUMENT, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setDocumentUploadDetails(response.data);
        setSponosoreDetails({
          ...sponosoreDetails,
          sponsoredDocumentGuid: response.data.blobResponse.blobFileName,
          sponsoredDocument: response.data.blobResponse.fileName,
        });
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  const getSponsoredValues = () => {
    apiClient
      .post(
        GET_DROPDOWN_FOR_PLANTATION_BATCH,
        {
          urn: urn,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setSponsoredType(response.data.Sponsored);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    setSponosoreDetails({
      ...sponosoreDetails,
      [e.target.name]:
        e.target.name === "sponsoredRemarks"
          ? VALIDATION.noSpecialCharacterValidation(e.target.value)
          : e.target.value,
    });

    if (e.target.name === "isSponsored") {
      setErrorMessage({
        ...errorMessage,
        isSponsoredError: "",
        sponsoredTypeError: "",
        sponsoredRemarksError: "",
        sponsoredDocumentError: "",
      });
    }
    if (e.target.name === "sponsoredType") {
      setErrorMessage({ ...errorMessage, sponsoredTypeError: "" });
    }
    if (e.target.name === "sponsoredRemarks") {
      setErrorMessage({ ...errorMessage, sponsoredRemarksError: "" });
    }
    if (e.target.name === "sponsoredDocument") {
      setErrorMessage({ ...errorMessage, sponsoredDocumentError: "" });
    }
  };

  const onNext = (e) => {
    e.preventDefault();

    const userData = {
      sponsoredDetails: sponosoreDetails,
    };

    if (sponosoreDetails && sponosoreDetails?.isSponsored === "no") {
      navigate("addPlantationbatch", {
        state: {
          sponsoredata: userData,
          urn: state?.urn,
          growerName: state?.growerName,
          landName: state?.landName,
          landId: state?.landId,
          possibleClumpsToGrow: state?.possibleClumpsToGrow,
          landArea: state?.landArea,
          availableLandArea: state?.availableLandArea,
          growerType: state?.growerType,
          state: state?.state,
          district: state?.district,
        },
      });
    } else {
      if (!sponosoreDetails?.sponsoredType) {
        setErrorMessage({
          ...errorMessage,
          sponsoredTypeError: "Please select sponsored type",
        });
      } else if (!sponosoreDetails.sponsoredRemarks) {
        setErrorMessage({
          ...errorMessage,
          sponsoredRemarksError: "Please write description",
        });
      } else if (!documentUploadDetails?.blobResponse?.fileName) {
        setErrorMessage({
          ...errorMessage,
          sponsoredDocumentError: "Please upload a document",
        });
      } else {
        navigate("addPlantationbatch", {
          state: {
            sponsoredata: userData,
            urn: state?.urn,
            growerName: state?.growerName,
            landName: state?.landName,
            landId: state?.landId,
            possibleClumpsToGrow: state?.possibleClumpsToGrow,
            availableLandArea: state?.availableLandArea,
            growerType: state?.growerType,
          },
        });
      }
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      {!PROD && <p className="pageNumberingResc">RES22</p>}

      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <BackButton
          navigate={navigate}
          onBack={() => {
            const savedData = sessionStorage.getItem("growersListData");

            if (state?.backTo) {
              navigate(state.backTo, {
                state: savedData ? JSON.parse(savedData) : {},
              });
            } else {
              navigate(-1);
            }
          }}
        />
        <Typography variant="h5" fontWeight={600}>
          Add Sponsorship Details
        </Typography>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          mb: 3,
          p: 2,
          borderRadius: 3,
          border: "1px solid #e6eaf0",
          backgroundColor: "#fafbfd",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Grower URN
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>
              {state?.urn || "-"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Grower Name
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>
              {state?.growerName || "-"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Land Name
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>
              {getLocalStorageItem("role")
                ? state?.landName
                : state?.data?.selectedLand?.landName || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 3,
          border: "1px solid #e6eaf0",
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={2}>
          Sponsorship Information
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl>
              <FormLabel className="sponsored-labels">
                ABEPL Sponsored?<span className="mandatory_field">*</span>
              </FormLabel>
              <RadioGroup row name="row-radio-buttons-group">
                <FormControlLabel
                  control={<Radio />}
                  label="Yes"
                  name="isSponsored"
                  value="yes"
                  onChange={(e) => handleChange(e)}
                  checked={sponosoreDetails.isSponsored === "yes"}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="No"
                  name="isSponsored"
                  value="no"
                  onChange={(e) => handleChange(e)}
                  checked={sponosoreDetails.isSponsored === "no"}
                />
              </RadioGroup>
            </FormControl>
            {errorMessage.isSponsoredError && (
              <div className="error-msg">{errorMessage.isSponsoredError}</div>
            )}
          </Grid>

          {sponosoreDetails?.isSponsored === "yes" && (
            <>
              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="mappedstakeholder-label">
                    Select sponsorship type
                    <span className="mandatory_field">*</span>
                  </InputLabel>
                  <Select
                    label="Select sponsorship type*"
                    name="sponsoredType"
                    value={sponosoreDetails.sponsoredType}
                    onChange={(e) => handleChange(e)}
                  >
                    {sponsoredType &&
                      sponsoredType.map((sponsored, index) => (
                        <MenuItem key={index} value={sponsored.value}>
                          {sponsored.value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <div className="error-msg">{errorMessage.sponsoredTypeError}</div>
              </Grid>

              <Grid item xs={12} md={12} lg={8} />

              <Grid item xs={12} md={8} lg={6}>
                <TextField
                  fullWidth
                  label="Sponsored Remarks *"
                  multiline
                  rows={5}
                  inputProps={{
                    maxLength: openTextFieldMaxLength,
                  }}
                  value={sponosoreDetails.sponsoredRemarks}
                  name="sponsoredRemarks"
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter sponsorship remarks"
                />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={0.5}
                >
                  <div className="error-msg">{errorMessage.sponsoredRemarksError}</div>
                  <Typography variant="caption" color="text.secondary">
                    {sponosoreDetails.sponsoredRemarks?.length || 0}/
                    {openTextFieldMaxLength}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={8} lg={6}>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  mb={1}
                  className="sponsored-labels"
                >
                  Upload Document<span className="mandatory_field">*</span>
                </Typography>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    borderStyle: "dashed",
                    backgroundColor: "#fcfcfd",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                  >
                    <label className="chooseFile-plantation" style={{ marginBottom: 0 }}>
                      <input
                        style={{ display: "none" }}
                        type="file"
                        accept="image/jpeg, image/png, .txt, .doc, .pdf, .csv, .ppt, .mp4"
                        name="sponsoredDocument"
                        onChange={(e) => uploadDocument(e)}
                      />
                      Choose File
                    </label>

                    <Box sx={{ minHeight: "24px", wordBreak: "break-word" }}>
                      <Typography variant="body2" color="text.secondary">
                        {documentUploadDetails?.blobResponse?.fileName
                          ? documentUploadDetails?.blobResponse?.fileName
                          : "No file selected"}
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>

                <div className="error-msg">{errorMessage.sponsoredDocumentError}</div>
              </Grid>
            </>
          )}
        </Grid>

        <Box display="flex" justifyContent="flex-end" mt={4}>
          <Button
            sx={{
              minWidth: 120,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
            variant="contained"
            onClick={(e) => onNext(e)}
          >
            Next
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default PlantationSponsored; 